import styles from './ErrorPage.module.scss';

export const AuthorizationError = () => {
	return (
		<div className={styles['error']}>
			<h1>Resource Access Error</h1>
			<p>
				We’re sorry, but there seems to be an issue with your access
				rights to the resource. Please, contact your administrator for
				support.
			</p>
		</div>
	);
};
